enum CreativeFileTagType {
  Standard = 'STANDARD_TAG',
  Javascript = 'JAVASCRIPT_TAG',
  IFrame = 'IFRAME_TAG',
  Vast20 = 'VAST_2_0_TAG',
  Vast30 = 'VAST_3_0_TAG',
  Vast40 = 'VAST_4_0_TAG',
}

export default CreativeFileTagType;
